<script lang="ts">
	import type { QuoteBlock } from './QuoteBlockQuery';
	import { getContext } from 'svelte';

	const { data }: { data: QuoteBlock } = $props();

	// default || fullbleed
	const layout: string = getContext('page-layout') ?? 'default';
</script>

<div class={`outer-container ${layout}`}>
	<div class="container">
		<p class="text text:description-large">"{data.text}"</p>
		{#if data.name}
			<p class="name text:description">- {data.name}</p>
		{/if}
	</div>
</div>

<style lang="scss">
	.outer-container {
		@include blockPaddingSmall;
	}

	.default {
		width: 100%;
		@include md {
			width: cols(7, 5);
		}
	}

	.name {
		padding-top: 42px;
	}

	.fullbleed-center {
		@include layoutBlockGrid;
		.container {
			grid-column: 1 / -1;
			padding-left: 36px;
			border-left: 5px solid hsl(var(--color-primary));

			@include md {
				grid-column: 4 / span 5;
			}
		}
	}

	.fullbleed {
		@include layoutBlockGrid;
		.container {
			grid-column: 1 / -1;
			padding-left: 36px;
			border-left: 5px solid hsl(var(--color-primary));

			@include md {
				grid-column: 6 / span 5;
			}
		}
	}
</style>
